import { Navigate } from 'react-router-dom';
import { useIsManager } from '@/access/usePerm';
import { HomePage } from '@/features/home/HomePage';
import { shouldEnterConsole, useIsWide } from './desktop';

/**
 * הבית. בטלפון זו תמיד אפליקציית העובד, גם למנהל. במסך רחב מנהל
 * מגיע לקונסולה (ראו src/app/desktop.ts).
 *
 * אין כאן המתנה ל me: RequireAuth כבר מבטיח שהוא נטען ואינו null
 * לפני שהילדים מרונדרים, ולכן ההרשאות ידועות מהרינדור הראשון ואין
 * הבהוב של אפליקציית העובד לפני ההפניה.
 */
export function HomeEntry() {
  const isManager = useIsManager();
  const isWide = useIsWide();

  if (shouldEnterConsole({ isManager, isWide })) {
    return <Navigate to="/admin" replace />;
  }

  return <HomePage />;
}
